'use strict';

angular.module('atex.art').factory('UIConfigurationService', ['$rootScope', '$q', 'UserProfileService',
  function ($rootScope, $q, UserProfileService) {
    var _templates;

    var profile = function () {
      return UserProfileService.getUserProfile({"application": "act"}).then(function (configuration) {
        return configuration.data;
      });
    };

    function _component(componentName, component, componentId) {
      return profile().then(function (_profile) {
        var components = _profile[component] || {};

        return _.find(components, function (configuration) {
          return (configuration.componentId === componentId);
        });
      });
    }

    function equals(resource, to) {
      return {
        "valid": (resource === to)
      };
    }

    function notEquals(resource, to) {
      return {
        "valid": (resource !== to)
      };
    }

    function notEmpty(resources) {
      var _valid = (resources !== undefined && resources.length > 0);
      var _size = (_valid) ? resources.length : 0;

      return {
        "valid": _valid,
        "size": _size
      };
    }

    function isNull(resource) {
      return {
        "valid": (_null(resource))
      };
    }

    function notNull(resource) {
      return {
        "valid": (!_null(resource))
      };
    }

    function _null(resource) {
      return (!resource);
    }

    function contains(resource, to) {
      return {
        "valid": (_.contains(resource, to))
      };
    }

    function notContains(resource, to) {
      return {
        "valid": (!_.contains(resource, to))
      };
    }

    function validate(_entry, ruleset) {
      var fields = atex.onecms.ObjectUtils.getByPath(ruleset, "fields") || [];
      var operator = atex.onecms.ObjectUtils.getByPath(ruleset, "operator") || "OR";

      var _fields = _.map(fields, function (field) {
        var _valid = {"valid": false, "size": 0};

        var path = atex.onecms.ObjectUtils.getByPath(field, "path");
        var dimension = atex.onecms.ObjectUtils.getByPath(field, "dimension");
        var queryField = atex.onecms.ObjectUtils.getByPath(field, "query-field");
        var condition = atex.onecms.ObjectUtils.getByPath(field, "condition") || "";
        var to = atex.onecms.ObjectUtils.getByPath(field, "to") || "";
        var _in = atex.onecms.ObjectUtils.getByPath(field, "in") || "";
        var label = atex.onecms.ObjectUtils.getByPath(field, "label");
        var icon = atex.onecms.ObjectUtils.getByPath(field, "icon");

        var _field = [];

        if(path) {
          _field =  atex.onecms.ObjectUtils.getByPath(_entry, path);
        } else if(dimension) {
          var _dimensions = atex.onecms.ObjectUtils.getByPath(_entry, "_data/aspects/atex.Metadata/data/metadata/dimensions") || [];

          var _dimension = _.find(_dimensions, function (_dimension) {
            return _dimension.id === dimension;
          });

          if(_dimension) {
            _field = _.map(_dimension.entities, function(entity) {
              return entity.id;
            });
          }
        } else if(queryField) {
          if (_entry.fields) {
            var found = _entry.fields.find(function (field) {
              return field.key === queryField;
            });

            _field = (found) ? found.values : undefined;
          }
        }

        if (condition === "NOT-EMPTY") {
          _valid = notEmpty(_field);
        } else if (condition === "IS-NULL") {
          _valid = isNull(_field);
        } else if (condition === "NOT-NULL") {
          _valid = notNull(_field);
        } else if (condition === "EQUALS") {
          _valid = equals(_field, to);
        } else if (condition === "NOT-EQUALS") {
          _valid = notEquals(_field, to);
        } else if (condition === "CONTAINS") {
          _valid = contains(_field, to);
        } else if (condition === "NOT-CONTAINS") {
          _valid = notContains(_field, to);
        } else if (condition === "CONTAINS-IGNORE-CASE") {
          _in = _.map(_in, function(_to) {
            return _to.toLocaleLowerCase();
          });

          if(_field) {
            _field = _field.toLocaleLowerCase();
          }
          _valid = contains(_in, _field);
        }

        _valid.icon = icon;
        _valid.label = label;

        return _valid;
      });

      var template = {"valid": false};
      if (operator === "OR") {
        var entry = _.find(_fields, function (value) {
          return (value.valid);
        }) || {valid: false};

        template.valid = entry.valid;
      } else if (operator === "AND") {
        template.valid = _.every(_fields, function (value) {
          return (value.valid);
        });
      }

      template.fields = _fields;

      return template;
    }

    $rootScope.$on('atex:logout', function () {
      _templates = undefined;
    });

    return {
      template: function (componentName, componentId) {
        return _component(componentName, "templates-list", componentId).then(function (component) {
          return atex.onecms.ObjectUtils.getByPath(component, "templates") || [];
        });
      },

      filter: function (componentName, componentId, templates) {
        if (!_templates) {
          return this.template(componentName, componentId).then(function (contents) {
            _templates = _.filter(templates, function (template) {
              return (contents.indexOf(template.id) > -1);
            });
            return _templates;
          }).then(null, function () {
            _templates = templates;
            return _templates;
          });
        } else {
          return $q.when(_templates);
        }
      },

      visible: function(component, type, entry) {
        return profile().then(function (_profile) {
          var _configurations = atex.onecms.ObjectUtils.getByPath(_profile,  component) || [];
          var configuration = _configurations.find(function (_configuration) {
            return _configuration.type === type;
          }) || {};

          var visible = atex.onecms.ObjectUtils.getByPath(configuration, 'visible');
          var rules = atex.onecms.ObjectUtils.getByPath(configuration, 'visible-if');

          if(visible !== undefined) {
            return visible;
          } else if(rules) {
            return validate(entry, rules).valid;
          }
        });
      },

      isToolbarVisible: function (type, entry) {
        return this.visible('toolbar-configurations/toolbars', type, entry);
      },

      getToolbarBackgroundStyleButton: function(type) {
        return profile().then(function (_profile) {
          var _configurations = atex.onecms.ObjectUtils.getByPath(_profile,  'toolbar-configurations/toolbars') || [];
          var configuration = _configurations.find(function (_configuration) {
            return _configuration.type === type;
          }) || {};
          return atex.onecms.ObjectUtils.getByPath(configuration, 'background-style');
        });
      },

      dropDown: function (componentName, componentId) {
        return _component(componentName, "toolbar-configurations", componentId).then(function (component) {
          return component;
        });
      },
    };
  }]).directive('uiDropDownMenu', ['UIConfigurationService',
  function (UIConfigurationService) {
    return {
      restrict: 'ACE',
      templateUrl: 'views/ui-configuration/menu/ui-dropdown-menu.html',
      replace: true,

      scope: {
        componentName: "@",
        componentId: "@",
      },

      controller: function ($scope) {
        $scope.items = [];

        function configure() {
          UIConfigurationService.dropDown($scope.componentName, $scope.componentId).then(function (configuration) {
            var items = atex.onecms.ObjectUtils.getByPath(configuration, "items") || [];
            $scope.items = angular.copy(items);
          });
        }

        configure();

        $scope.$on("atex:logout", function () {
          $scope.items.length = 0;
        });

        $scope.$on("onecms:authenticationSuccess", function () {
          configure();
        });
      },

      link: function (scope) {}
    };
  }]);